import React, { Component } from 'react';
class Resume extends Component {
    render() {
  
      if(this.props.data){
        var university = this.props.data.university;
        var college = this.props.data.college;
        var startdate = this.props.data.startdate;
        var enddate = this.props.data.enddate;
        var logo = "images/"+this.props.data.guc_logo;
        var GPA = this.props.data.GPA;
        var school = this.props.data.school;
        var experiences = this.props.data.work.map(function(experience){
            return <div key={experience.company_name}><h3>{experience.company_name}</h3>
                <p className="info">
                <div className="two columns">
                            <a target="_blank" rel="noopener noreferrer" href={experience.company_website} title={experience.company_name}>
                            <img className="profile-pic"  src={"images/"+experience.company_logo} alt={experience.company_name+"LOGO"}/>
                            </a>
                </div>
                {experience.title}<br/><br/>
                <span>&bull;</span> <em className="date">{experience.starting_date} - {experience.ending_date} </em></p>
                <p>{experience.description1}</p>
                <p>{experience.description2}</p>
            </div>
        })
        var sfskills = this.props.data.software.map(function(skill){
            return <div key={skill.language}><h4>{skill.language}</h4>
                    <p className="info">
                        <span>&bull;</span> 
                        <em className="date">{skill.description}</em>
                    </p>
                </div>  
        })

        var barskills = this.props.data.bar_skills.map(function(bars){
            var className = 'bar-expand '+bars.name.toLowerCase();
            return <li key={bars.name} ><span style={{width:bars.level}}className={className} ></span><em>{bars.name}</em></li>
          })
    }
    return (
        <section id="resume">

            <div className="row education">
                <div className="three columns header-col">
                    <h1><span>{this.props.isGerman ? "Ausbildung" : "Education"}</span></h1>
                </div>
    
            <div className="nine columns main-col">
            <div className="row item">
                    <div className="twelve columns">
                        <h3>{university}</h3>
                        <div className="three columns">
                            <a target="_blank" rel="noopener noreferrer" href="http://www.guc.edu.eg/" title="The German University in Cairo">
                            <img className="profile-pic"  src={logo} alt="GUC LOGO"/>
                            </a>
                         </div>
                         <br/>
                         <br/>
                        <p className="info">
                             {college}<br/>
                             <span>&bull;</span><em className="date">{this.props.isGerman ? "Gestartet im: " : "Started in: "}{startdate}</em><br/>
                           <span>&bull;</span><em className="date">{this.props.isGerman ? "Voraussichtlicher Abschluss im: " : "Expected to graduate in: "} {enddate}</em>
                         </p>
                    </div>
                </div>  
                <h3>{school}</h3>
                <p className="info">
                    <span>&bull;</span><em className="date">{GPA}</em><br/>
                </p>        
            </div>
        </div>
        <div className="row work">
                <div className="three columns header-col">
                    <h1><span>{this.props.isGerman ? "Erfahrung" : "Experience"}</span></h1>
                </div>

                <div className="nine columns main-col">
                    {experiences}
                </div>
        </div>
        <div className="row work">
            <div className="three columns header-col">
               {this.props.isGerman ? <h2><span> Software-Kenntnisse </span></h2> : <h1><span>Software Skills</span></h1>}
             </div>
             <div className="nine columns main-col">
                {sfskills}
             </div>
        </div> 

         <div className="row skill">
         <div className="three columns header-col">
             <h1><span>{this.props.isGerman ? "Softwareebene" : "Software Levels"}</span></h1>
         </div>

         <div className="nine columns main-col">
                <div className="bars">
                <p>
                     {this.props.isGerman ? "Hier sind einige meiner Software-Kenntnisse und die Fähigkeit, sie zu verwenden." : "Here are levels in some of my software skills and the ability in using them."}
                </p><br/>
                    <ul className="skills">
                        {barskills}
                    </ul>
                </div>
		  </div>
      </div>
  

        </section>
  
);
        
    }
}
export default Resume;
